import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';
import { companyPropTypes } from '../../../../proptypes/companyProptypes';

// Styles
import styles from './companyLogo.module.scss';

const CompanyLogo = ({ job, company }) => {
  if (!job.extra_info?.can_be_disclosed || !company.logo_url) {
    return null;
  }

  return (
    <div className={styles.logo}>
      <Image
        src={company.logo_url}
        alt={`${company.company_name}`}
        layout="fill"
        objectFit="contain"
        objectPosition="left"
        priority
      />
    </div>
  );
};

CompanyLogo.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  company: PropTypes.shape(companyPropTypes).isRequired,
};

export default CompanyLogo;
